import { SocietyEquityMarketStatus } from 'types/Society';
import { IncentivesMarketAdminPanelContextType } from '../types/IncentivesMarketAdminPanelContextType';

export const incentivesMarketAdminPanelInitValue: IncentivesMarketAdminPanelContextType =
  {
    data: {
      societyId: '',
      societyName: '',
      incentivesMarketStatus: SocietyEquityMarketStatus.OPEN,
      sellOffers: [],
      buyOffers: [],
      operations: [],
      sellOffersSummary: { offersCount: 0, unitsCount: 0, totalAmount: 0 },
      buyOffersSummary: { offersCount: 0, unitsCount: 0, totalAmount: 0 },
      pendingOperationsCount: 0,
      partners: [],
      isAdmin: false,
      isLoading: true,
    },
    actions: {
      handleGoBack: () => {},
      handleIncentivesMarketStatusChange: () => {},
      handleViewOfferDetail: () => {},
      handleViewOperationDetail: () => {},
      handleUpdateOperationStatus: () => {},
      handleTogglePartnerIncentivesMarketAccess: () => {},
    },
  };
